/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Divider, Drawer, IconButton, Step, StepLabel, Stepper, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import { LoadingPage } from "../../../../../common/LoadingPage";
import { showNotification } from "../../../../../common/Notification/ToastifyNotification";
import CommonDestination from "../../Items/CommonDestination";
import { useSelector } from "react-redux";
import DisplaySelection from "./DisplaySelection";
import Fields from "./Fields";
import { apiRequest } from "../../../../../common/common";
import { RoomFields } from "../../../../../common/const";


const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 5px 5px 15px'
}));


const CopyMoveRoom = ({
    departmentOpen,
    setDepartmentOpen,
    isMove,
    setIsMove,
    selectedData,
    setSelectedData,
    projectData,
    onGridReady
}) => {
    let steps = [];
    if (isMove) {
        steps = ['Selection', 'Destination'];
    } else {
        steps = ['Selection', 'Destination', 'Fields']
    }
    const { user } = useSelector(state => state.users);
    const [item, setItem] = useState({});
    const [tableData, setTableData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [data, setProjectData] = useState(projectData);
    const [displayArr, setDisplayArr] = useState([]);
    const [fields, setFields] = useState(RoomFields);

    const handleClose = () => {
        setDepartmentOpen(false);
        setSelectedData([]);
        setIsMove(false);
        setItem(null);
        setActiveStep(0);
        onGridReady();
    }

    const handleNext = () => {
        if (activeStep === 1 && tableData.length === 0) {
            showNotification('Please select destination', 'error');
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }

    const handleSubmit = async () => {
        if (tableData?.length > 0) {
            setDataLoading(true);
            try {
                item.organization_id = user?.organization?.organization_id;
                item.field_status = fields.reduce((acc, { label, reset_enabled }) => {
                    acc[label] = isMove ? true : reset_enabled;
                    return acc;
                }, {});
                item.department_ids = tableData?.map((a) => a.department_id);
                item.is_move = isMove;
                const response = await apiRequest('post', '/project-room/copy-move', item);
                if (response.data) {
                    handleClose();
                    showNotification(response?.data.message, 'success');
                }
            } catch (error) {
                setDataLoading(false);
                showNotification(error?.response?.data.error || error.message, 'error');
            }
        } else {
            showNotification('Please select destination before proceed', 'error');
        }
    }

    useEffect(() => {
        if (selectedData.length > 0) {
            const arr = selectedData.map((d) => ({
                room_id: d.room_id,
                quantity: d.quantity,
                room_name: d?.room_name,
                department_name: d?.department?.department_name,
                level_name: d.level?.level_name,
                building_name: d.building?.building_name,
                project_name: projectData?.name
            }));
            setDisplayArr(arr);
        }
    }, [selectedData]);

    useEffect(() => {
        if (displayArr.length > 0) {
            item.room_data = displayArr.map((d) => ({
                room_id: d.room_id,
                room_name: d.room_name,
                quantity: d.quantity
            }));
            setItem(item);
        }
    }, [displayArr]);

    return (
        <Drawer
            anchor="bottom"
            open={departmentOpen}
            sx={{
                '& .MuiDrawer-paper': {
                    height: '88%',
                }
            }}
        >
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <DemoBox1>
                <Typography variant='body1' style={{ fontWeight: 'bold' }}>{isMove ? 'Move to Destination' : 'Copy to Destination'}</Typography>
                <Box>
                    {activeStep > 0 && (
                        <Button variant='outlined' size="small" onClick={() => handleBack()} style={{ marginRight: 5 }}>
                            Back
                        </Button>
                    )}
                    {isMove ? (
                        <>
                            {activeStep < 1 && (
                                <Button variant='contained' size="small" onClick={() => handleNext()}>
                                    Next
                                </Button>
                            )}
                            {activeStep === 1 && (
                                <Button variant='contained' size="small" onClick={() => handleSubmit()}>
                                    Save
                                </Button>
                            )}
                        </>
                    ) : (
                        <>

                            {activeStep < 2 && (
                                <Button variant='contained' size="small" onClick={() => handleNext()}>
                                    Next
                                </Button>
                            )}
                            {activeStep === 2 && (
                                <Button variant='contained' size="small" onClick={() => handleSubmit()}>
                                    Save
                                </Button>
                            )}
                        </>
                    )}
                    <IconButton onClick={() => handleClose()}>
                        <ClearIcon />
                    </IconButton>
                </Box>
            </DemoBox1>
            <Divider />
            <Box sx={{ width: '100%', padding: activeStep !== 2 ? '10px' : '5px 0px 0px 0px' }}>
                <Stepper activeStep={activeStep} style={{ marginBottom: '5px' }}>
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                <Divider />
            </Box>
            {activeStep === 0 && (
                <DisplaySelection
                    displayArr={displayArr}
                    setDisplayArr={setDisplayArr}
                />
            )}
            {activeStep === 1 && (
                <CommonDestination
                    projectData={data}
                    setProjectData={setProjectData}
                    tableData={tableData}
                    setTableData={setTableData}
                    fromCatalog
                    innerLabel="Room"
                    displayDestination
                    isMove={isMove}
                    selectedData={selectedData}
                />
            )}
            {activeStep === 2 && (
                <Fields
                    fields={fields}
                    setFields={setFields}
                />
            )}
        </Drawer>
    )
}

export default CopyMoveRoom;